import React from "react";

function ExpiredIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4459_7050)">
        <path
          d="M6.77649 1.19922V4.5446M13.4672 1.19922V4.5446"
          stroke="#F44336"
          strokeWidth="1.42696"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.9765 2.87305H4.26766C3.34386 2.87305 2.59497 3.62194 2.59497 4.54574V16.2546C2.59497 17.1784 3.34386 17.9272 4.26766 17.9272H15.9765C16.9003 17.9272 17.6492 17.1784 17.6492 16.2546V4.54574C17.6492 3.62194 16.9003 2.87305 15.9765 2.87305Z"
          stroke="#F44336"
          strokeWidth="1.42696"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.59497 7.89062H17.6492M11.7948 11.236L8.44938 14.5814M8.44938 11.236L11.7948 14.5814"
          stroke="#F44336"
          strokeWidth="1.42696"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4459_7050">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default ExpiredIcon;
